import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { RotateCcwIcon } from 'lucide-react';
import { useCompletion } from '../contexts/CompletionContext';
import { allSlots } from '../data/calendar';
import type { DeadlineStatus } from '../utils/status';
import { getStatus, statusStyles } from '../utils/status';
import { StatusLegend } from './StatusLegend';
export function DeliveryStatus({
  showReset = false
}: {
  showReset?: boolean;
}) {
  const {
    isDone,
    clearAll
  } = useCompletion();
  const counts = useMemo(() => {
    const base: Record<DeadlineStatus, number> = {
      clear: 0,
      soon: 0,
      critical: 0,
      done: 0
    };
    allSlots.forEach(s => {
      base[getStatus(s.date, isDone(s.id ?? ''))] += 1;
    });
    return base;
  }, [isDone]);
  const total = allSlots.length;
  const pct = Math.round(counts.done / total * 100);
  const order: DeadlineStatus[] = ['done', 'critical', 'soon', 'clear'];
  return <div data-id="element-50" data-mp="496qmvxw343">
      <div className="flex items-baseline justify-between gap-3" data-id="element-51" data-mp="4hiuck8n4e8">
        <p className="font-mono text-[11px] text-mute" data-id="element-52" data-mp="36nxstfefpup5">
          <span className="font-display text-2xl text-chalk" data-id="element-53" data-mp="36n4qqrqf7tdc">{counts.done}</span> of {total} anchor slots ticked off
        </p>
        <span className="font-mono text-[11px] text-faint" data-id="element-54" data-mp="3fo2ynl3zcl17">{pct}%</span>
      </div>

      <div className="mt-3 flex h-2.5 w-full overflow-hidden rounded-full bg-ink-800" role="img" aria-label="Anchor slots by deadline status" data-id="element-55" data-mp="3fm9ss816y4u9">
        {order.map(status => counts[status] > 0 ? <motion.span key={status} layout initial={false} animate={{
        width: `${counts[status] / total * 100}%`
      }} transition={{
        duration: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className={`block h-full ${statusStyles[status].rail}`} data-id="element-56" data-mp="2ryi568a7a5do" /> : null)}
      </div>

      <div className="mt-4 flex flex-wrap items-center justify-between gap-3" data-id="element-57" data-mp="248nthu1mamv0">
        <StatusLegend counts={counts} data-id="element-58" data-mp="296pkr2975shk" />
        {showReset && counts.done > 0 && <button type="button" onClick={clearAll} className="flex items-center gap-1.5 rounded-lg border border-ink-700 px-2.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.14em] text-mute transition-colors hover:border-ink-600 hover:text-chalk" data-id="element-59" data-mp="2169kbyjbybix">
            <RotateCcwIcon className="h-3 w-3" aria-hidden="true" data-id="element-60" data-mp="25z2puommhnw2" />
            Reset
          </button>}
      </div>
    </div>;
}